import './bootstrap'
import Container from './Container.vue'
import CategoryProductList from 'glonass/shop/site/widgets/product-list/Widget.vue'
import ProductList from 'glonass/shop/site/widgets/category-product-list/Widget.vue'
import OfferList from 'glonass/shop/site/widgets/offer-list/Widget.vue'
import CartInfo from 'glonass/shop/site/widgets/cart-info/Widget.vue'
import Cart from 'glonass/shop/site/widgets/cart/Widget.vue'
import Order from 'glonass/shop/site/widgets/order/Widget.vue'
import store from './store'

// Пишем стор в глобальную переменную, чтобы отдавать компонентам.
global.siteStore = store

/**
 * Регистрация всех используемых компонентов.
 */
if (process.env.NODE_ENV === 'production') {
  /* eslint-disable no-undef */
  Vue.component(CategoryProductList.name, CategoryProductList)
  Vue.component(ProductList.name, ProductList)
  Vue.component(OfferList.name, OfferList)
  Vue.component(CartInfo.name, CartInfo)
  Vue.component(Cart.name, Cart)
  Vue.component(Order.name, Order)
}

/**
 * Для тестирования в hot-режиме.
 */
if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-new */
  /* eslint-disable no-undef */
  new Vue({
    el: '#app',
    store,
    render: h => h(Container)
  })
}

// /**
//  * Здесь будет export default { компоненты } когда будет umd и можно будет получить ссылку на компонент
//  */
// export default {
//   ProductList,
//   install (Vue) {
//     Vue.component(ProductList.name, ProductList)
//   }
// }
//
// Vue.use(RamilLib)
// new Vue({
//   el: '',
//   render: (h) => h(RamilLib.Container, {
//     props: {}
//   })
// })



// WEBPACK FOOTER //
// ./resources/assets/site/app.js